"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _OverlayModule = _interopRequireDefault(require("./../../scss/utils/Overlay.module.scss"));
function Overlay({
  appendToElement,
  state = 'entering'
}) {
  /**
   * creates a new div in which to place the modal/dialog
   */
  const createPortalElement = () => {
    const check = document.querySelector('#overlay');
    if (!check) {
      const modalDiv = document.createElement('div');
      modalDiv.setAttribute('id', 'overlay');
      modalDiv.setAttribute('class', `${_OverlayModule.default['overlay']} overlay`);
      modalDiv.setAttribute('data-state', 'entering');
      appendToElement.append(modalDiv);
    }
  };
  createPortalElement();
  const wait = setInterval(() => {
    const overlayEl = document.querySelector('#overlay');
    if (overlayEl) {
      const closeOverlay = e => {
        const event = new CustomEvent('scripps:overlay:closed');
        document.dispatchEvent(event);
        overlayEl.setAttribute('data-state', 'exiting');
        setTimeout(() => {
          overlayEl.remove();
        }, 400);
      };
      clearInterval(wait);
      overlayEl.addEventListener('click', closeOverlay);
    }
  });
  (0, _react.useEffect)(() => {
    var _document$querySelect;
    (_document$querySelect = document.querySelector('#overlay')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.setAttribute('data-state', state);
  }, [state]);
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), document.getElementById('overlay'));
}
var _default = exports.default = Overlay;